import { BugsnagService, BugsnagServiceModule } from '@b2b/common/services/bugsnag';
import postRobot from '@krakenjs/post-robot';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IScope } from 'angular';

export class SsoCallbackController {
  static $inject = ['$scope', '$state', 'BugsnagService'];

  constructor(private $scope: IScope, private $state: StateService, private bugsnagService: BugsnagService) {}

  $onInit() {
    const RelayState = this.$state.params.RelayState === 'null' ? null : (this.$state.params.RelayState as string);
    const targetWindow = window.opener as Window | null;

    this.bugsnagService.notify(new Error(`RelayState must be a string, received \`${RelayState}\``), (event) => {
      event.context = 'sso.callback.error';
    });

    postRobot
      .send(targetWindow, 'sso.callback', {
        source: 'acme-b2b-app',
        type: 'sso.callback',
        data: { RelayState },
      })
      .then((event) => {
        window.close();
      })
      .catch((error) => {
        console.error(error);
        this.bugsnagService.notify(new Error(error), (event) => {
          event.context = 'sso.callback.error';
        });
      });
  }
}

export const AuthSsoCallbackControllerModule = angular
  .module('acme.view.auth.sso.controllers.sso-callback', [
    uiRouter,
    'acme.common.service.api',
    'acme.common.service.auth',
    BugsnagServiceModule,
  ])
  .controller('SsoCallbackController', SsoCallbackController).name;
